import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnInit, } from '@angular/core';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';

import * as d3 from 'd3';

import { DashboardService } from 'src/app/_services/dashboards.service';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';

declare var CallPainting: any;


@Component({
  selector: 'DCO-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  standalone: false,
})
export class DashboardComponent extends BaseComponent  implements OnInit {
  @Input() type: string;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient,
    public override router: Router, 
    private route: ActivatedRoute,
    private elementRef: ElementRef, private DashboardService: DashboardService, public override langService: LanguageManagerService) { 

    super(router, langService, route);
  }

  chartSeries: any[] = [];
  selectedGrouping: number = 1;
  selectedGroupingReasons: number = 1;
  dateFrom: string = '';
  dateTo: string = '';
  minDate: string;
  maxDate: string;

  private resizeCallbacks: { [key: string]: () => void } = {};

  @HostListener('window:resize')
  onResize() {
    Object.values(this.resizeCallbacks).forEach(draw => draw());
  }

  override ngOnInit(): void {
    super.ngOnInit();
    const hoy = new Date();
    const haceUnAño = new Date();
    haceUnAño.setFullYear(hoy.getFullYear() - 1);

    const haceDosAnios = new Date();
    haceDosAnios.setFullYear(hoy.getFullYear() - 2);

    this.maxDate = hoy.toISOString().split('T')[0];
    this.minDate = haceDosAnios.toISOString().split('T')[0];

    this.initDefaultDates();

    const filters = {
      from: haceUnAño.toISOString(), 
      to: hoy.toISOString(),
      dateAggrupation: 2,
      supportGroupID: [],
      contactGroupID: []
    };

    this.loadDashboardData("trendtotaldisputesDCO", "chartTotal", "Total disputas", filters);
    this.loadDashboardData("trendmonthlyaverage", "chartMedia", "Media entrada al mes", filters);
    this.loadDashboardData("trendsuccessrate", "chartExito", "Tasa de éxito", filters);
    this.loadDashboardData("trendaverageamountDCO", "chartImporte", "Importe medio por disputa", filters);
    this.onGroupingChange();
    this.onGroupingReasonsChange()
    this.loadPieChart("piereasons", "chartPieContainer", "Motivos reclamaciones", filters);
    this.loadLandscapeChart("landscapebycommerce", "chartlandscapeContainer", "Comercios con más disputas", filters);    
  }

  private loadDashboardData(idService: string, chartId: string, title: string, filters: any): void {
    this.DashboardService.Get(idService, filters).subscribe({
      next: (res) => {
        const drawAction = () => {
          d3.select(`#${chartId}`).selectAll("*").remove();
          const seriesForD3 = res.chart.series.map(s => ({
            Type: s.type,
            Name: s.name
          }));

          Object.entries(res.equivalences).forEach(([key, value]) => {
            if (value.startsWith('@@') ) {
              res.equivalences[key] = this.langService.translate(`${value}`);
            }
          });

          //console.log(res.equivalences)

          CallPainting(
            res.chartType,
            chartId,
            title,
            JSON.stringify(res.data),
            JSON.stringify(res.equivalences),
            JSON.stringify(seriesForD3),
            JSON.stringify({}),
            0, 0
          );
        }
        this.resizeCallbacks[chartId] = drawAction;
        drawAction();
      }
    });
  }

  loadStackedChart(idService: string, chartId: string, title: string, filters: any): void {
    this.DashboardService.Get(idService, filters).subscribe({
      next: (res) => {
        const drawAction = () => {
          const container = document.getElementById(chartId);
          const dynamicWidth = container ? container.offsetWidth : 800;

          d3.select(`#${chartId}`).selectAll("*").remove();

          Object.entries(res.equivalences).forEach(([key, value]) => {
            if (value.startsWith('@@') ) {
              res.equivalences[key] = this.langService.translate(`${value}`);
            }
          });

          //console.log(res.equivalences)

          const friendlyEquivalences = {
            ...res.equivalences
          };

          const seriesForD3 = res.chart.series.map((s: any) => ({
            Name: s.name,
            Color: s.color
          }));

          this.chartSeries = res.chart.series.map((s: any) => ({
            Name: s.name,
            DisplayName: res.equivalences[s.name] || s.name,
            Color: s.color
          }));

          CallPainting(
            "columnsstacked",
            chartId,
            title,
            JSON.stringify(res.data),
            JSON.stringify(friendlyEquivalences),
            JSON.stringify(seriesForD3),
            JSON.stringify({ type: "Base" }),
            dynamicWidth,
            res.chart.size.height
          );

          if (typeof res.data === 'object') {
            if (Object.keys(res.data)[0].includes('Sem')) {
              const targetDiv = container?.querySelector('.DashboardChartContiner');
              const svg = targetDiv?.querySelector('svg');
              svg.setAttribute('height', `${res.chart.size.height+15}`);
            }
          }

        }
        this.resizeCallbacks[chartId] = drawAction;
        drawAction();
      }
    });
  }

  onGroupingChange(): void {
    const filters = {
      from: new Date(this.dateFrom).toISOString(),
      to: new Date(this.dateTo).toISOString(),
      dateAggrupation: Number(this.selectedGrouping),
      supportGroupID: [],
      contactGroupID: []
    };

    this.loadStackedChart("columnsstackedbystate", "chartStackedContainer", "Evolución disputas por estado", filters);
  }

  onGroupingReasonsChange(): void {
    const filters = {
      from: new Date(this.dateFrom).toISOString(),
      to: new Date(this.dateTo).toISOString(),
      dateAggrupation: Number(this.selectedGroupingReasons),
      supportGroupID: [],
      contactGroupID: []
    };

    this.loadStackedChart("columnsstackedbyreasons", "chartStackedReasonContainer", "Evolución disputas por motivo", filters);
  }

  private initDefaultDates(): void {
    const hoy = new Date();
    const haceUnAño = new Date();
    haceUnAño.setFullYear(hoy.getFullYear() - 1);

    this.dateTo = hoy.toISOString().split('T')[0];
    this.dateFrom = haceUnAño.toISOString().split('T')[0];
  }

  private loadPieChart(idService: string, chartId: string, title: string, filters: any): void {
    this.DashboardService.Get(idService, filters).subscribe({
      next: (res) => {
        const drawAction = () => {
          const container = document.getElementById(chartId);
          let dynamicWidth = container ? container.offsetWidth : 400;
          //console.log(res)
          if (res.chart.size != null) {
            dynamicWidth = res.chart.size.width;
          }
          d3.select(`#${chartId}`).selectAll("*").remove();

          Object.entries(res.equivalences).forEach(([key, value]) => {
            if (value.startsWith('@@') ) {
              res.equivalences[key] = this.langService.translate(`${value}`);
            }
          });

          const seriesForD3 = res.chart.series.map((s: any) => ({
            Name: s.name,
            Color: s.color
          }));

          if (res.chart.legend.grouping == null) {
            res.chart.legend.grouping = []
          }

          CallPainting(
            "pie",
            chartId,
            title,
            JSON.stringify(res.data),
            JSON.stringify(res.equivalences),
            JSON.stringify(seriesForD3),
            JSON.stringify(res.chart.legend),
            //JSON.stringify({ Position: "Right" }),
            dynamicWidth,
            res.chart.size.height
          );
        }
        this.resizeCallbacks[chartId] = drawAction;
        drawAction();
      }
    });
  }

  loadLandscapeChart(idService: string, chartId: string, title: string, filters: any): void {
    this.DashboardService.Get(idService, filters).subscribe({
      next: (res) => {
        const drawAction = () => {
          const container = document.getElementById(chartId);
          const dynamicWidth = container ? container.offsetWidth : 400;
          d3.select(`#${chartId}`).selectAll("*").remove();

          const friendlyEquivalences = {
            ...res.equivalences
          };

          const seriesForD3 = res.chart.series.map((s: any) => ({
            Name: s.name,
            Color: s.color
          }));

          this.chartSeries = res.chart.series.map((s: any) => ({
            Name: s.name,
            DisplayName: res.equivalences[s.name] || s.name,
            Color: s.color
          }));

          // 3. Llamada a D3
          CallPainting(
            "landscape",
            chartId,
            title,
            JSON.stringify(res.data),
            JSON.stringify(friendlyEquivalences),
            JSON.stringify(seriesForD3),
            JSON.stringify({ type: "None" }),
            dynamicWidth,
            350
          );
        }
        this.resizeCallbacks[chartId] = drawAction;
        drawAction();
      }
    });
  }
}